import { service } from "../utils/request";

//  所有的素材列表
export function materialAll(data) {
  return service({
    url: "/wechat/agent.image/all",
    method: "post",
    data: data
  });
}
// 已上传素材列表
export function materialList(data) {
  return service({
    url: "wechat/agent.image/getList",
    method: "post",
    data: data
  });
}
export function materialDel(data) {
  return service({
    url: "wechat/agent.image/delImage",
    method: "post",
    data: data
  });
}
// 添加客服消息
export function detailMessage(data) {
  return service({
    url: "/wechat/agent.messages/messageDetail",
    method: "post",
    data: data
  });
}
// 添加客服消息
export function addMessage(data) {
  return service({
    url: "wechat/agent.messages/addMessage",
    method: "post",
    data: data
  });
}
// 删除客服消息
export function delMessage(data) {
  return service({
    url: "wechat/agent.messages/delMessage",
    method: "post",
    data: data
  });
}
// 编辑客服消息
export function editMessage(data) {
  return service({
    url: "wechat/agent.messages/editMessage",
    method: "post",
    data: data
  });
}
export function sendList(data) {
  return service({
    url: "/wechat/agent.messages/sendList",
    method: "post",
    data: data
  });
}
// 发送客服消息
export function send(data) {
  return service({
    url: "/wechat/agent.messages/send",
    method: "post",
    data: data
  });
}
// 获取预览二维码
export function preview(data) {
  return service({
    url: "wechat/agent.messages/preview",
    method: "post",
    data: data
  });
}
// 智能推送
export function smartRuleList(data) {
  return service({
    url: "/wechat/agent.message_wisdom/rule",
    method: "post",
    data: data
  });
}
export function smartRuleDel(data) {
  return service({
    url: "/wechat/agent.message_wisdom/delRule",
    method: "post",
    data: data
  });
}
export function smartRuleDetail(data) {
  return service({
    url: "/wechat/agent.message_wisdom/detailRule",
    method: "post",
    data: data
  });
}
export function smartRuleAdd(data) {
  return service({
    url: "/wechat/agent.message_wisdom/addRule",
    method: "post",
    data: data
  });
}
export function smartRuleEditor(data) {
  return service({
    url: "/wechat/agent.message_wisdom/editRule",
    method: "post",
    data: data
  });
}
